module.exports = __webpack_public_path__ + "img/5.861f36c8.jpg";